export const time_condition = {
  modal: {
    remove: {
      content: `Вы действительно хотите удалить расписание <b>{name}<b>?`
    },

    add_interval: {
      days: 'Выбор дней недели',
      worktime: 'Выбор рабочего времени'
    }
  },

  form: {
    title: {
      edit: {
        main: 'Данные расписания'
      }
    },

    buttons: {
      create_time_interval: 'Добавить интервал'
    }
  },

  table: {
    field: {
      timezone: 'Часовой пояс'
    }
  }
};
